import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=1a7e55bf&scoped=true&"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmation.vue?vue&type=style&index=0&id=1a7e55bf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e55bf",
  null
  
)

export default component.exports